import React from 'react';
import { Tabs } from 'antd';

const MobileProjectTabs = ({ activeTab, onChange, languageMap }) => {
    const tabItems = [
        {
            key: 'projectInformation',
            label: languageMap?.["modal.mobile.project.tab.projectInfo"] ?? "Project Info"
        },
        {
            key: 'taskProperty',
            label: languageMap?.["modal.mobile.project.tab.taskProperty"] ?? "Task Property"
        },
        {
            key: 'workflow',
            label: languageMap?.["modal.mobile.project.tab.workflow"] ?? "Workflow"
        },
        {
            key: 'authority',
            label: languageMap?.["modal.mobile.project.tab.authority"] ?? "Authority"
        }
    ];

    return (
        <div className="mobile-project-tabs">
            <Tabs
                activeKey={activeTab}
                onChange={onChange}
                items={tabItems}
                destroyInactiveTabPane
                centered
                type="line"
            />
        </div>
    );
};

export default MobileProjectTabs;